import React from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from 'react-redux';
import { HIDE_LOGIN_SUCCESS_MODAL } from '../../redux/_user.redux';
import NotificationIcon from '../../assets/images/notification_icon.svg';

const GlobalNotification = () => {
    const dispatch = useDispatch();

    const isOpen = useSelector((state) => state.user.showLoginSuccessModal);
    const handleClose = () => {
        dispatch({ type: HIDE_LOGIN_SUCCESS_MODAL });
    };

    return (
        <Dialog
            open={!!isOpen}
            onClose={(_, reason) => {
                if (reason !== 'backdropClick') {
                    handleClose();
                }
            }}
            disableEscapeKeyDown
            hideBackdrop
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    overflow: 'visible'
                }
            }}
        >
            <IconButton
                onClick={handleClose}
                aria-label="閉じる"
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    zIndex: 1,
                    color: 'transparent',
                    backgroundColor: 'transparent',
                    '&:hover': {
                        backgroundColor: 'transparent'
                    },
                    '& .MuiSvgIcon-root': {
                        opacity: 0
                    }
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent sx={{ p: 0, backgroundColor: 'transparent', overflow: 'visible' }}>
                <img
                    src={NotificationIcon}
                    style={{ width: '100%', display: 'block', cursor: 'pointer', backgroundColor: 'transparent' }}
                    alt="notice"
                    onClick={handleClose}
                />
            </DialogContent>
        </Dialog>
    );
};

export default GlobalNotification;
